import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/performance/hok.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-526a564e")

_pushScopeId("data-v-526a564e")
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = { style: {"position":"fixed","z-index":"1000","top":"0","left":"0","right":"0"} }
const _hoisted_3 = {
  class: "new_head",
  style: {"width":"100%","background":"#2d3136","height":"62px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("img", {
      style: {"height":"44px","width":"48px","border-radius":"10px","margin-right":"10px"},
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "HOK 内存性能平台")
], -1)
const _hoisted_5 = { style: {"position":"absolute","top":"62px","left":"0","right":"0","bottom":"0","overflow-y":"auto"} }
const _hoisted_6 = { style: {"width":"100%","padding":"50px","background":"#222529"} }
const _hoisted_7 = { style: {"background":"#2d3136"} }
const _hoisted_8 = { class: "custom-tabs-label" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { style: {"color":"#fff"} }, "测试数据总览", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("配置基线")
const _hoisted_11 = { class: "config_class" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = { class: "config_class" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, "捕获内存", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "(MB)", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("|")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("|")
const _hoisted_19 = /*#__PURE__*/_createVNode("div", null, "(MB)", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("|")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("|")
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_24 = { class: "spacName" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存趋势图 ")
], -1)
const _hoisted_26 = { class: "stask_title" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_28 = { class: "custom-tabs-label" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { style: {"color":"#fff"} }, "测试数据详情", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "删除", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("总内存分配 ")
], -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存风险Top增长子模块 ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("总体内存分配趋势图 ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", {
  id: "memory_all",
  style: {"height":"400px","width":"100%"}
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存子模块数据查看 ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_40 = {
  "element-loading-background": "#393E44",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "stask_title" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("当前版本 ")
], -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%"},
  id: "stackSub",
  class: "chart-area"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "stask_title" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("当前版本 ")
], -1)
const _hoisted_44 = { class: "stask_title" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_46 = {
  key: 0,
  style: {"width":"100%"},
  id: "stackSubOld",
  class: "chart-area"
}
const _hoisted_47 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_48 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存子模块变化趋势图 ")
], -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", {
  id: "moudle_sub",
  style: {"height":"400px","width":"100%"}
}, null, -1)
const _hoisted_50 = { class: "native_table" }
const _hoisted_51 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("全量内存数据查看 ")
], -1)
const _hoisted_52 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 导出数据")
const _hoisted_54 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("主要函数内存分配趋势图 ")
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", {
  id: "function_trend",
  style: {"height":"400px","width":"100%"}
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("指定火焰图查询 ")
], -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_58 = { "element-loading-background": "#393E44" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%"},
  id: "stackAppointStack",
  class: "chart-area"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle spacName"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("指定火焰图对比 ")
], -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_62 = {
  "element-loading-background": "#393E44",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "stask_title" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("当前版本 ")
], -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%"},
  id: "stackAppointStackLeft",
  class: "chart-area"
}, null, -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "stask_title" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("当前版本 ")
], -1)
const _hoisted_66 = { style: {"width":"47.5%"} }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "stask_title" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("对比版本 ")
], -1)
const _hoisted_68 = {
  key: 0,
  style: {"width":"100%"},
  id: "stackAppointStackRight",
  class: "chart-area"
}
const _hoisted_69 = {
  key: 1,
  style: {"width":"100%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_calendar = _resolveComponent("calendar")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", null, [
          _createVNode("span", null, [
            _createVNode("img", {
              style: {"height":"50px","width":"55px","border-radius":"25px"},
              src: 
                'https://dayu.woa.com/avatars/' + _ctx.name_img + '/profile.jpg'
              
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.activeName = $event)),
            type: "card",
            class: "tabs_color",
            onTabClick: _ctx.handleClick
          }, {
            default: _withId(() => [
              _createVNode(_component_el_tab_pane, { name: "first" }, {
                label: _withId(() => [
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_el_icon, null, {
                      default: _withId(() => [
                        _createVNode(_component_calendar)
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_card, {
                    class: "cont_seond",
                    style: {"background":"#2d3136"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        class: "hok_label_form",
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.object_options_model, (i, k, index) => {
                            return (_openBlock(), _createBlock(_component_el_form_item, {
                              key: index,
                              label: _ctx.optiosn_list_label[k]
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  onChange: _ctx.confirm,
                                  size: "mini",
                                  modelValue: _ctx.object_options_model[k],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.object_options_model[k] = $event),
                                  placeholder: "请选择",
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optiosn_list[k], (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: k == 'device' ? item.name : item,
                                        value: k == 'device' ? item.device_id : item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128)),
                          _createVNode(_component_el_form_item, { label: "模块" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                size: "mini",
                                modelValue: _ctx.moudel_list_eight,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.moudel_list_eight = $event)),
                                placeholder: "请选择",
                                multiple: "",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudel_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.configShow = true)),
                                type: "primary"
                              }, {
                                default: _withId(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_el_dialog, {
                          width: "40%",
                          modelValue: _ctx.configShow,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.configShow = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "机型" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.deviceChange,
                                      modelValue: _ctx.device_id,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.device_id = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.device_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "基线版本" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      key: _ctx.componentKey,
                                      modelValue: _ctx.base_id,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.base_id = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_device_option, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _ctx.settingsBtn
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_12
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode(_component_el_dialog, {
                          width: "30%",
                          modelValue: _ctx.configShow_old,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.configShow_old = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "对比版本" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      key: _ctx.componentKey,
                                      modelValue: _ctx.old_id,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.old_id = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_option_new, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _ctx.settingsBtn_old
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createVNode("div", null, [
                        _withDirectives(_createVNode(_component_el_table, {
                          class: "spacName my-table-hok",
                          "element-loading-background": "#393E44",
                          size: "mini",
                          "header-cell-style": {
                      background: '#42484E',
                      color: '#fff',
                    },
                          "span-method": _ctx.mergeCells,
                          data: _ctx.object_list_table
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "设备" }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.data.device.model.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "日期",
                              prop: "date"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 
                            'margin-left:' +
                            (scope.row.data.level == 0 ? '0px' : '10px')
                          
                                }, [
                                  _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                                  (scope.row.data.level == 0 && scope.row.show)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (_ctx.expandCheck(scope.row)),
                                        class: 
                              scope.row.check
                                ? 'el-icon-arrow-down'
                                : 'el-icon-arrow-up'
                            
                                      }, null, 10, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 4)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "130",
                              label: "版本对比(当前|上一版本|基准)"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", null, _toDisplayString(scope.row.data.cur_version), 1),
                                _createVNode("div", null, _toDisplayString(scope.row.data.old_version
                              ? scope.row.data.old_version
                              : "--"), 1),
                                _createVNode("div", null, _toDisplayString(scope.row.data.base_version
                              ? scope.row.data.base_version
                              : "--"), 1)
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudel_Sum, (i, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                align: "center",
                                key: index
                              }, {
                                header: _withId(() => [
                                  _hoisted_15,
                                  _hoisted_16
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i))
                                  }, _toDisplayString(scope.row.data.module[i].cur), 9, ["onClick"]),
                                  _hoisted_17,
                                  _createVNode("span", {
                                    style: [{"cursor":"pointer"}, 
                            'color:' +
                            _ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_old,
                              i
                            )[0]
                          ],
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i, 'last'))
                                  }, _toDisplayString(_ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_old,
                              i
                            )[1]), 13, ["onClick"]),
                                  _hoisted_18,
                                  _createVNode("span", {
                                    style: [{"cursor":"pointer"}, 
                            'color:' +
                            _ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_base,
                              i
                            )[0]
                          ],
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i, 'base'))
                                  }, _toDisplayString(_ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_base,
                              i
                            )[1]), 13, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudel_list_eight, (i, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                align: "center",
                                key: index,
                                label: (i == 'Sum' ? '捕获内存' : i) + '(MB)'
                              }, {
                                header: _withId(() => [
                                  _createVNode("div", null, _toDisplayString(i), 1),
                                  _hoisted_19
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i))
                                  }, _toDisplayString(scope.row.data.module[i].cur), 9, ["onClick"]),
                                  _hoisted_20,
                                  _createVNode("span", {
                                    style: [{"cursor":"pointer"}, 
                            'color:' +
                            _ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_old,
                              i
                            )[0]
                          ],
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i, 'last'))
                                  }, _toDisplayString(_ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_old,
                              i
                            )[1]), 13, ["onClick"]),
                                  _hoisted_21,
                                  _createVNode("span", {
                                    style: [{"cursor":"pointer"}, 
                            'color:' +
                            _ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_base,
                              i
                            )[0]
                          ],
                                    onClick: ($event: any) => (_ctx.download(scope.row.data, i, 'base'))
                                  }, _toDisplayString(_ctx.get_com_risk_color(
                              scope.row.data.module[i].diff_base,
                              i
                            )[1]), 13, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, {
                              width: "100",
                              align: "center",
                              label: "原始数据下载"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("a", {
                                  class: "link-like",
                                  download: `${
                            scope.row.data.time +
                            '_' +
                            scope.row.data.device.UUID +
                            '_' +
                            scope.row.data.level +
                            '_' +
                            scope.row.data.scene_name
                          }.zip`,
                                  href: scope.row.data.filepath
                                }, "下载", 8, ["download", "href"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "80",
                              align: "center",
                              label: "数据详情"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.data.cur_version)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      class: "link-like",
                                      onClick: ($event: any) => (_ctx.view(scope.row.data))
                                    }, "查看", 8, ["onClick"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_22, "查看"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "80",
                              label: "操作"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_popconfirm, {
                                  onConfirm: ($event: any) => (_ctx.handleDeleteScene(scope.row.data)),
                                  title: "确定删除"
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      type: "primary"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["span-method", "data"]), [
                          [_directive_loading, _ctx.test_data_loading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_el_form, {
                          class: "spacForm hok_label_form",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "时间选择" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_date_picker, {
                                  onChange: _ctx.moudleChange,
                                  modelValue: _ctx.pick,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.pick = $event)),
                                  type: "daterange",
                                  "range-separator": "To",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期"
                                }, null, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "设备" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.moudleChange,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.trend.device,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.trend.device = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.name,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  onChange: _ctx.moudleChange,
                                  size: "mini",
                                  modelValue: _ctx.trend.scene,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.trend.scene = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "内存子模块" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.trend.moudle,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.trend.moudle = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  onChange: _ctx.moudle_confirm,
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle_list, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trend.device, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "spacName",
                            key: item
                          }, [
                            _createVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createTextVNode(_toDisplayString(_ctx.device_options.filter((v) => v.device_id == item)[0]
                          .name), 1)
                            ]),
                            _withDirectives(_createVNode(_component_el_card, {
                              class: "object_card spacName",
                              "element-loading-background": "#393E44"
                            }, {
                              default: _withId(() => [
                                _createVNode("div", {
                                  id: item,
                                  style: {"height":"400px","width":"100%"}
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1536), [
                              [_directive_loading, _ctx.test_data_trend_loading]
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, { name: "second" }, {
                label: _withId(() => [
                  _createVNode("span", _hoisted_28, [
                    _createVNode(_component_el_icon, null, {
                      default: _withId(() => [
                        _createVNode(_component_calendar)
                      ]),
                      _: 1
                    }),
                    _hoisted_29
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_card, {
                    style: {"background":"#2d3136"},
                    class: "cont_seond"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        class: "hok_label_form",
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "测试类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeDate(true, true))),
                                size: "mini",
                                modelValue: _ctx.overView.type,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.overView.type = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.object_type_options, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item.name,
                                      value: item.report_type
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择日期" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeDate(false, true))),
                                filterable: "",
                                size: "mini",
                                modelValue: _ctx.overView.name,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.overView.name = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_option, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item.name,
                                      value: item.name
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择设备" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeDate(false, false))),
                                filterable: "",
                                size: "mini",
                                modelValue: _ctx.overView.device,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.overView.device = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options_second, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item.name,
                                      value: item.device_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_popconfirm, {
                                title: "将删除该任务下的选择的机型数据",
                                onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.deleteBtn())),
                                placement: "top"
                              }, {
                                reference: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_31,
                      _withDirectives(_createVNode(_component_el_table, {
                        class: "spacName my-table-hok",
                        size: "mini",
                        "element-loading-background": "#393E44",
                        "header-cell-style": {
                    background: '#42484E',
                    color: '#fff',
                  },
                        data: _ctx.all_memoryData
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: "测试场景",
                            prop: "scene"
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: "测试画质",
                            prop: "level"
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: '当前版本:' + _ctx.all_report.cur_version + '(MB)'
                          }, {
                            default: _withId((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.data.current.size), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: 
                      '基线前后变化值:' + _ctx.all_report.base_version + '(MB)'
                    
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", {
                                style: 'color:' + scope.row.data.base_color
                              }, _toDisplayString(scope.row.data.BaseDiff), 5)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: '前后变化值:' + _ctx.all_report.old_version + '(MB)'
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", {
                                style: 'color:' + scope.row.data.last_color
                              }, _toDisplayString(scope.row.data.LastDiff), 5)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: "风险"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", {
                                style: 'color:' + _ctx.risk_color_text(scope.row.data.risk)
                              }, _toDisplayString(scope.row.data.risk), 5)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.memory_report]
                      ]),
                      (_ctx.perfReport_top.length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_32, [
                            _hoisted_33,
                            _withDirectives(_createVNode(_component_el_table, {
                              "element-loading-background": "#393E44",
                              class: "custom-table_top my-table-hok",
                              size: "mini",
                              "span-method": _ctx.mergeCells1,
                              "header-cell-style": {
                      background: '#42484E',
                      color: '#fff',
                    },
                              data: _ctx.perfReport_top
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "测试画质" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.level), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "版本对比" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.version), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "150",
                                  label: "测试场景"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "150",
                                  label: "UnreleasedNative内存变化(MB)"
                                }, {
                                  header: _withId(() => [
                                    _hoisted_34
                                  ]),
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.diif_new), 1),
                                    _createVNode("span", {
                                      style: 
                            'color:' + _ctx.risk_color(scope.row.memory_diff)[1]
                          
                                    }, "(" + _toDisplayString(_ctx.risk_color(scope.row.memory_diff)[0]) + ")", 5)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  "show-overflow-tooltip": true,
                                  width: "550",
                                  label: "Top增长模块(MB)"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.moudelName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  width: "180",
                                  align: "center",
                                  label: "增长未释放"
                                }, {
                                  header: _withId(() => [
                                    _hoisted_35
                                  ]),
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.diff), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["span-method", "data"]), [
                              [_directive_loading, _ctx.memory_report]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", null, [
                        _hoisted_36,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.allmemoryChange,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.overView.level,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.overView.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "hok_label_form",
                              label: "时间选择"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_date_picker, {
                                  onChange: _ctx.allmemoryChange,
                                  modelValue: _ctx.overView.pick,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.overView.pick = $event)),
                                  type: "daterange",
                                  "range-separator": "To",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期"
                                }, null, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_card, {
                          class: "spacName object_card",
                          "element-loading-background": "#393E44"
                        }, {
                          default: _withId(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.all_memory_loading]
                        ])
                      ]),
                      _createVNode("div", null, [
                        _hoisted_38,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.sub_moudel_change,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel.level,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.sub_moudel.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.sub_moudel_change,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel.scene,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.sub_moudel.scene = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.sub_moudel_change,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel.old_name,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.sub_moudel.old_name = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_option, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.name,
                                        value: item.name
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form, {
                          class: "hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "搜索" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.sub_moudel.serch,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.sub_moudel.serch = $event)),
                                  onChange: _ctx.sub_moudel_change,
                                  "prefix-icon": "el-icon-search",
                                  size: "mini"
                                }, null, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Top" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.sub_moudel_change,
                                  modelValue: _ctx.sub_moudel.top,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.sub_moudel.top = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          "element-loading-background": "#393E44",
                          onSortChange: _ctx.sort_change_in,
                          class: "spacName my-table-hok",
                          size: "mini",
                          "header-cell-style": {
                      background: '#42484E',
                      color: '#fff',
                    },
                          data: 
                      _ctx.sub_moudel_data?.list?.slice(
                        (_ctx.sub_moudel.page - 1) * _ctx.sub_moudel.size,
                        _ctx.sub_moudel.page * _ctx.sub_moudel.size
                      )
                    
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "测试场景",
                              prop: "scene"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "测试画质",
                              prop: "level"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "内存子类",
                              prop: "module_name"
                            }),
                            _createVNode(_component_el_table_column, {
                              width: "280",
                              prop: "size",
                              sortable: "custom",
                              align: "center",
                              label: 
                        '当前版本:' + _ctx.sub_moudel_data.new_version + '(MB)'
                      
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.stackSubBtn(scope.row.module_name, 'new'))
                                }, _toDisplayString(scope.row.size), 9, ["onClick"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              width: "280",
                              prop: "diff_base",
                              sortable: "custom",
                              align: "center",
                              label: 
                        '基线变化值:' + _ctx.sub_moudel_data.base_version + '(MB)'
                      
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  onClick: ($event: any) => (_ctx.stackSubBtn(scope.row.module_name, 'old')),
                                  style: 
                            'cursor: pointer;color:' + scope.row.risk_base
                          
                                }, _toDisplayString(scope.row.diff_base), 13, ["onClick"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              width: "280",
                              prop: "diff_old",
                              sortable: "custom",
                              align: "center",
                              label: 
                        '前后变化值:' + _ctx.sub_moudel_data.old_version + '(MB)'
                      
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  onClick: ($event: any) => (_ctx.stackSubBtn(scope.row.module_name, 'base')),
                                  style: 'cursor: pointer;color:' + scope.row.risk_old
                                }, _toDisplayString(scope.row.diff_old), 13, ["onClick"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "风险"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 'color:' + _ctx.risk_color_text(scope.row.risk)
                                }, _toDisplayString(scope.row.risk), 5)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onSortChange", "data"]), [
                          [_directive_loading, _ctx.sub_moudel_list_loading]
                        ]),
                        _createVNode(_component_el_form, {
                          class: "hok_label_form",
                          inline: true,
                          size: "mini",
                          style: {"display":"flex","align-items":"center"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "每页" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.sub_moudel.size,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.sub_moudel.size = $event)),
                                  style: {"width":"55px","height":"28px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "条记录" }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  currentPage: _ctx.sub_moudel.page,
                                  "onUpdate:currentPage": _cache[27] || (_cache[27] = ($event: any) => (_ctx.sub_moudel.page = $event)),
                                  "page-size": _ctx.sub_moudel.size,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _ctx.sub_moudel_data?.list?.length
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "内存子模块" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  modelValue: _ctx.sub_moudel.module,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.sub_moudel.module = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_moudel_data?.module_list, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.subMemoryChange,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_39
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode("div", _hoisted_40, [
                          (_ctx.ObjectStackSubData?.children?.length > 0)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                style: 'width:' + _ctx.stack_width_sub + '%'
                              }, [
                                _hoisted_41,
                                _hoisted_42
                              ], 4))
                            : (_openBlock(), _createBlock("div", {
                                key: 1,
                                style: 'width:' + _ctx.stack_width_sub + '%'
                              }, [
                                _hoisted_43,
                                _createVNode(_component_el_empty, {
                                  style: {"width":"100%"},
                                  description: "无堆栈数据"
                                })
                              ], 4)),
                          (_ctx.sub_old_show)
                            ? (_openBlock(), _createBlock("div", {
                                key: 2,
                                style: 'height:100%;width:' + _ctx.stack_width_sub_old + '%'
                              }, [
                                _createVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _createTextVNode(_toDisplayString(_ctx.stack_sub_title), 1)
                                ]),
                                (_ctx.ObjectStackSubDataOld?.children?.length > 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_46))
                                  : (_openBlock(), _createBlock("div", _hoisted_47, [
                                      _createVNode(_component_el_empty, {
                                        style: {"width":"100%"},
                                        description: "无堆栈数据"
                                      })
                                    ]))
                              ], 4))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_directive_loading, _ctx.sub_stack_loading]
                        ])
                      ]),
                      _createVNode("div", null, [
                        _hoisted_48,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel_trend.level,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.sub_moudel_trend.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.sub_moudel_trend_change(true))),
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel_trend.scene,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.sub_moudel_trend.scene = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "搜索子类" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.sub_moudel_trend_change(false))),
                                  modelValue: _ctx.sub_moudel_trend.moudel,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.sub_moudel_trend.moudel = $event)),
                                  class: "input_none",
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle_list_second, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_card, {
                          "element-loading-background": "#393E44",
                          class: "spacName object_card"
                        }, {
                          default: _withId(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.sub_moudel_loading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createVNode("div", _hoisted_52, [
                          _createVNode(_component_el_form, {
                            class: "spacName hok_label_form",
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择画质" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.alldata_change,
                                    filterable: "",
                                    size: "mini",
                                    modelValue: _ctx.all_data.level,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.all_data.level = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.alldata_change,
                                    filterable: "",
                                    size: "mini",
                                    modelValue: _ctx.all_data.scene,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.all_data.scene = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.alldata_change,
                                    filterable: "",
                                    size: "mini",
                                    modelValue: _ctx.all_data.old_name,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.all_data.old_name = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_option, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item.name,
                                          value: item.name
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", null, [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.downloadCsv()))
                            }, {
                              default: _withId(() => [
                                _hoisted_53
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          class: "hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "搜索" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.all_data.serch,
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.all_data.serch = $event)),
                                  "on@change": _ctx.alldata_change,
                                  "prefix-icon": "el-icon-search",
                                  size: "mini"
                                }, null, 8, ["modelValue", "on@change"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Top" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.alldata_change,
                                  modelValue: _ctx.all_data.top,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.all_data.top = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          "element-loading-background": "#393E44",
                          class: "my-table-hok spacName",
                          size: "mini",
                          "header-cell-style": {
                      background: '#42484E',
                      color: '#fff',
                    },
                          data: 
                      _ctx.memory_all_data_list?.slice(
                        (_ctx.all_data.page - 1) * _ctx.all_data.size,
                        _ctx.all_data.page * _ctx.all_data.size
                      )
                    ,
                          onSortChange: _ctx.sort_change
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "left",
                              sortable: "custom",
                              "show-overflow-tooltip": true,
                              label: "functionName",
                              prop: "functionName"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "left",
                              sortable: "custom",
                              "show-overflow-tooltip": true,
                              label: "sourceFileName",
                              prop: "sourceFileName"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "left",
                              sortable: "custom",
                              "show-overflow-tooltip": true,
                              label: "内存子模块部分",
                              prop: "moduleName"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              sortable: "custom",
                              prop: "size",
                              label: "数值",
                              width: "120"
                            }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.size), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              sortable: "custom",
                              prop: "diff",
                              label: "差异",
                              width: "120"
                            }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.diff), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              sortable: "custom",
                              prop: "risk",
                              width: "120",
                              label: "风险"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 
                            'cursor: pointer;color:' + scope.row.risk_color
                          
                                }, _toDisplayString(scope.row.risk), 5)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data", "onSortChange"]), [
                          [_directive_loading, _ctx.function_table_loading]
                        ]),
                        _createVNode(_component_el_form, {
                          class: "hok_label_form",
                          inline: true,
                          size: "mini",
                          style: {"display":"flex","align-items":"center"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "每页" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.all_data.size,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.all_data.size = $event)),
                                  style: {"width":"55px","height":"28px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "条记录" }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  currentPage: _ctx.all_data.page,
                                  "onUpdate:currentPage": _cache[41] || (_cache[41] = ($event: any) => (_ctx.all_data.page = $event)),
                                  "page-size": _ctx.all_data.size,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _ctx.memory_all_data_list?.length
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", null, [
                        _hoisted_54,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.functionChange(true))),
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.function_memory.level,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.function_memory.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.functionChange(true))),
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.function_memory.scene,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.function_memory.scene = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "搜索函数" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.functionChange(false))),
                                  modelValue: _ctx.function_memory.function,
                                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.function_memory.function = $event)),
                                  filterable: "",
                                  multiple: "",
                                  class: "input_none",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_list, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_card, {
                          "element-loading-background": "#393E44",
                          class: "spacName object_card"
                        }, {
                          default: _withId(() => [
                            _hoisted_55
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.function_loading]
                        ])
                      ]),
                      _createVNode("div", null, [
                        _hoisted_56,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.appointChange,
                                  modelValue: _ctx.appoint.level,
                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.appoint.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.appointChange,
                                  modelValue: _ctx.appoint.scene,
                                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.appoint.scene = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form, {
                          class: "spacForm hok_label_form",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "size" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  placeholder: "单位KB",
                                  modelValue: _ctx.appoint.size,
                                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.appoint.size = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "内存子模块" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.appoint.moudel,
                                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.appoint.moudel = $event)),
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle_list_appoint, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "function" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.appoint.func,
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.appoint.func = $event)),
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_list_appoint, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.flame_btn_appoint,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_57
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode("div", _hoisted_58, [
                          _hoisted_59
                        ], 512), [
                          [_directive_loading, _ctx.serch_stack_loading]
                        ])
                      ]),
                      _createVNode("div", null, [
                        _hoisted_60,
                        _createVNode(_component_el_form, {
                          class: "spacName hok_label_form",
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.appointOldChange,
                                  modelValue: _ctx.appointOld.level,
                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.appointOld.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.level_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.appointOldChange,
                                  modelValue: _ctx.appointOld.scene,
                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.appointOld.scene = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_second_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.appointOldChange,
                                  filterable: "",
                                  size: "mini",
                                  modelValue: _ctx.sub_moudel.old_name,
                                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.sub_moudel.old_name = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateVersion_option, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.name,
                                        value: item.name
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form, {
                          class: "spacForm hok_label_form",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "size" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  placeholder: "单位KB",
                                  modelValue: _ctx.appointOld.size,
                                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.appointOld.size = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "内存子模块" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.appointOld.moudel,
                                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.appointOld.moudel = $event)),
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle_list_appoint_old, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "function" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.appointOld.func,
                                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.appointOld.func = $event)),
                                  filterable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_list_appoint_old, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.flame_btn_appoint_old,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_61
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode("div", _hoisted_62, [
                          (_ctx.ObjectStackAppoinOldLeftData?.children?.length > 0)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                style: 'width:' + 47.5 + '%'
                              }, [
                                _hoisted_63,
                                _hoisted_64
                              ], 4))
                            : (_openBlock(), _createBlock("div", {
                                key: 1,
                                style: 'width:' + 47.5 + '%'
                              }, [
                                _hoisted_65,
                                _createVNode(_component_el_empty, {
                                  style: {"width":"100%"},
                                  description: "无堆栈数据"
                                })
                              ], 4)),
                          _createVNode("div", _hoisted_66, [
                            _hoisted_67,
                            (
                          _ctx.ObjectStackAppoinOldRightData?.children?.length > 0
                        )
                              ? (_openBlock(), _createBlock("div", _hoisted_68))
                              : (_openBlock(), _createBlock("div", _hoisted_69, [
                                  _createVNode(_component_el_empty, {
                                    style: {"width":"100%"},
                                    description: "无堆栈数据"
                                  })
                                ]))
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.con_stack_loading]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"])
        ])
      ])
    ])
  ]))
})